import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { BadgesFormMainSection } from './BadgesFormMainSection';

export type IBadgesFormValues = {
  badgeIds?: Array<string>;
};

export type IBadgesFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IBadgesFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<IBadgesFormValues>;
    onSubmit?: SubmitHandler<IBadgesFormValues>;
    appId: string;
  };

export const BadgesForm: React.FC<IBadgesFormProps> = (props) => {
  const { defaultValues, appId, ...other } = props;

  const form = useForm<IBadgesFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody form={form} {...other}>
      <BadgesFormMainSection form={form} appId={appId} />
    </ContentBlock.FormBody>
  );
};
